
export default function Footer() {
  const services = [
    'Auto Insurance',
    'Home Insurance', 
    'Life Insurance',
    'Business Insurance',
    'Health Insurance',
    'Specialty Coverage'
  ];

  const quickLinks = [
    'About Us',
    'Meet the Team',
    'Patient Portal',
    'Get a Quote',
    'Claims Support',
    'Contact Us'
  ];

  return (
    <footer className="bg-gray-900/95 backdrop-blur-sm text-white py-16 border-t border-gray-700/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="animate-fade-in-up opacity-0">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 mb-4 inline-block">
              <img 
                src="https://static.readdy.ai/image/7c34e572229199a03c653ba249394690/8c2de251b6b4c8837c068d068c7378f0.jfif" 
                alt="Insurance Doctors Logo" 
                className="h-14 w-auto object-contain filter brightness-125 contrast-110"
              />
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Providing expert insurance diagnosis and treatment for over 25 years. Your protection is our prescription.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors duration-300 cursor-pointer">
                <i className="ri-facebook-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors duration-300 cursor-pointer">
                <i className="ri-twitter-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors duration-300 cursor-pointer">
                <i className="ri-linkedin-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors duration-300 cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="animate-fade-in-up opacity-0" style={{ animationDelay: '200ms' }}>
            <h4 className="text-xl font-semibold mb-6">Insurance Services</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <a href="#" className="text-gray-300 hover:text-blue-400 transition-colors duration-200 cursor-pointer flex items-center">
                    <i className="ri-arrow-right-s-line text-blue-400 mr-2"></i>
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div className="animate-fade-in-up opacity-0" style={{ animationDelay: '400ms' }}>
            <h4 className="text-xl font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a href="#" className="text-gray-300 hover:text-blue-400 transition-colors duration-200 cursor-pointer flex items-center">
                    <i className="ri-arrow-right-s-line text-blue-400 mr-2"></i>
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="animate-fade-in-up opacity-0" style={{ animationDelay: '600ms' }}>
            <h4 className="text-xl font-semibold mb-6">Contact Information</h4>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-blue-400 text-xl mr-3 mt-1"></i>
                <div>
                  <p className="text-gray-300">13844 Alton Pkwy Suite 132</p>
                  <p className="text-gray-300">Irvine, CA 92618</p>
                </div>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-blue-400 text-xl mr-3"></i>
                <p className="text-gray-300">(949) 951-8119</p>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-blue-400 text-xl mr-3"></i>
                <p className="text-gray-300">info@theinsurancedoctors.com</p>
              </div>
              <div className="flex items-center">
                <i className="ri-time-line text-blue-400 text-xl mr-3"></i>
                <div>
                  <p className="text-gray-300">Mon-Fri: 9AM-5PM</p>
                  <p className="text-gray-300">After Hours: On Call</p>
                  <p className="text-gray-300">Weekends: By Appointment</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 mb-4 md:mb-0 animate-fade-in-up opacity-0" style={{ animationDelay: '800ms' }}>
              <p>&copy; 2024 The Insurance Doctors. All rights reserved.</p>
            </div>
            <div className="flex space-x-6 animate-fade-in-up opacity-0" style={{ animationDelay: '1000ms' }}>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-200 cursor-pointer">Privacy Policy</a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-200 cursor-pointer">Terms of Service</a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-200 cursor-pointer">Sitemap</a>
            </div>
          </div>
        </div>
        
        <div className="text-center mt-8 animate-fade-in-up opacity-0" style={{ animationDelay: '1200ms' }}>
          <p className="text-gray-400 text-sm">
            Licensed Insurance Professionals | Farmers Insurance Network Member
          </p>
        </div>
      </div>
    </footer>
  );
}
